<template>
  <div class="flex h-full w-full items-center" v-bind="$attrs">
    <slot name="summary" :is-open="isOpen" :set-open="setOpen" />
  </div>
  <div v-if="isOpen">
    <slot />
  </div>
</template>

<script setup lang="ts">
const isOpen = defineModel<boolean>({ default: false });

const setOpen = (value: boolean) => (isOpen.value = value);
</script>
